{
  "tencentcloud.ami": {
    "columns": [
      {
        "type": "string",
        "field": "ImageId",
        "headerName": "Image Id"
      },
      {
        "type": "string",
        "field": "OsName",
        "headerName": "Os Name"
      },
      {
        "type": "string",
        "field": "ImageType",
        "headerName": "Image Type"
      },
      {
        "type": "time",
        "field": "CreatedTime",
        "headerName": "Created Time"
      },
      {
        "type": "string",
        "field": "ImageName",
        "headerName": "Image Name"
      },
      {
        "type": "string",
        "field": "ImageDescription",
        "headerName": "Image Description"
      },
      {
        "type": "number",
        "field": "ImageSize",
        "headerName": "Image Size"
      },
      {
        "type": "string",
        "field": "Architecture",
        "headerName": "Architecture"
      },
      {
        "type": "string",
        "field": "ImageState",
        "headerName": "Image State"
      },
      {
        "type": "string",
        "field": "Platform",
        "headerName": "Platform"
      },
      {
        "type": "string",
        "field": "ImageCreator",
        "headerName": "Image Creator"
      },
      {
        "type": "string",
        "field": "ImageSource",
        "headerName": "Image Source"
      },
      {
        "type": "number",
        "field": "SyncPercent",
        "headerName": "Sync Percent"
      },
      {
        "type": "boolean",
        "field": "IsSupportCloudinit",
        "headerName": "Is Support Cloudinit"
      },
      {
        "type": "string",
        "field": "LicenseType",
        "headerName": "License Type"
      }
    ],
    "id": "ImageId"
  },
  "tencentcloud.cam-policy": {
    "columns": [
      {
        "type": "number",
        "field": "PolicyId",
        "headerName": "Policy Id"
      },
      {
        "type": "string",
        "field": "PolicyName",
        "headerName": "Policy Name"
      },
      {
        "type": "time",
        "field": "AddTime",
        "headerName": "Add Time"
      },
      {
        "type": "number",
        "field": "Type",
        "headerName": "Type"
      },
      {
        "type": "string",
        "field": "Description",
        "headerName": "Description"
      },
      {
        "type": "number",
        "field": "CreateMode",
        "headerName": "Create Mode"
      },
      {
        "type": "number",
        "field": "Attachments",
        "headerName": "Attachments"
      },
      {
        "type": "string",
        "field": "ServiceType",
        "headerName": "Service Type"
      },
      {
        "type": "number",
        "field": "IsAttached",
        "headerName": "Is Attached"
      },
      {
        "type": "number",
        "field": "Deactived",
        "headerName": "Deactived"
      },
      {
        "type": "array",
        "field": "DeactivedDetail",
        "headerName": "Deactived Detail"
      },
      {
        "type": "number",
        "field": "IsServiceLinkedPolicy",
        "headerName": "Is Service Linked Policy"
      },
      {
        "type": "number",
        "field": "AttachEntityCount",
        "headerName": "Attach Entity Count"
      },
      {
        "type": "number",
        "field": "AttachEntityBoundaryCount",
        "headerName": "Attach Entity Boundary Count"
      },
      {
        "type": "time",
        "field": "UpdateTime",
        "headerName": "Update Time"
      }
    ],
    "id": "PolicyId"
  },
  "tencentcloud.cam-user": {
    "columns": [
      {
        "type": "number",
        "field": "Uin",
        "headerName": "Uin"
      },
      {
        "type": "string",
        "field": "Name",
        "headerName": "Name"
      },
      {
        "type": "number",
        "field": "Uid",
        "headerName": "Uid"
      },
      {
        "type": "string",
        "field": "Remark",
        "headerName": "Remark"
      },
      {
        "type": "number",
        "field": "ConsoleLogin",
        "headerName": "Console Login"
      },
      {
        "type": "string",
        "field": "PhoneNum",
        "headerName": "Phone Num"
      },
      {
        "type": "string",
        "field": "CountryCode",
        "headerName": "Country Code"
      },
      {
        "type": "string",
        "field": "Email",
        "headerName": "Email"
      },
      {
        "type": "time",
        "field": "CreateTime",
        "headerName": "Create Time"
      },
      {
        "type": "string",
        "field": "NickName",
        "headerName": "Nick Name"
      }
    ],
    "id": "Uin"
  },
  "tencentcloud.cbs": {
    "columns": [
      {
        "type": "string",
        "field": "DiskId",
        "headerName": "Id"
      }
    ],
    "id": "DiskId"
  },
  "tencentcloud.cbs-snapshot": {
    "columns": [
      {
        "type": "string",
        "field": "Placement.Zone",
        "headerName": "Zone"
      },
      {
        "type": "string",
        "field": "Placement.CageId",
        "headerName": "Cage Id"
      },
      {
        "type": "number",
        "field": "Placement.ProjectId",
        "headerName": "Project Id"
      },
      {
        "type": "string",
        "field": "Placement.CdcName",
        "headerName": "Cdc Name"
      },
      {
        "type": "string",
        "field": "Placement.CdcId",
        "headerName": "Cdc Id"
      },
      {
        "type": "string",
        "field": "Placement.DedicatedClusterId",
        "headerName": "Dedicated Cluster Id"
      },
      {
        "type": "boolean",
        "field": "CopyFromRemote",
        "headerName": "Copy From Remote"
      },
      {
        "type": "string",
        "field": "SnapshotState",
        "headerName": "Snapshot State"
      },
      {
        "type": "boolean",
        "field": "IsPermanent",
        "headerName": "Is Permanent"
      },
      {
        "type": "string",
        "field": "SnapshotName",
        "headerName": "Snapshot Name"
      },
      {
        "type": "time",
        "field": "DeadlineTime",
        "headerName": "Deadline Time"
      },
      {
        "type": "number",
        "field": "Percent",
        "headerName": "Percent"
      },
      {
        "type": "number",
        "field": "ShareReference",
        "headerName": "Share Reference"
      },
      {
        "type": "string",
        "field": "SnapshotType",
        "headerName": "Snapshot Type"
      },
      {
        "type": "number",
        "field": "DiskSize",
        "headerName": "Disk Size"
      },
      {
        "type": "string",
        "field": "DiskId",
        "headerName": "Disk Id"
      },
      {
        "type": "array",
        "field": "CopyingToRegions",
        "headerName": "Copying To Regions"
      },
      {
        "type": "boolean",
        "field": "Encrypt",
        "headerName": "Encrypt"
      },
      {
        "type": "time",
        "field": "CreateTime",
        "headerName": "Create Time"
      },
      {
        "type": "number",
        "field": "ImageCount",
        "headerName": "Image Count"
      },
      {
        "type": "string",
        "field": "DiskUsage",
        "headerName": "Disk Usage"
      },
      {
        "type": "string",
        "field": "SnapshotId",
        "headerName": "Snapshot Id"
      },
      {
        "type": "time",
        "field": "TimeStartShare",
        "headerName": "Time Start Share"
      }
    ],
    "id": "SnapshotId"
  },
  "tencentcloud.clb": {
    "columns": [
      {
        "type": "string",
        "field": "LoadBalancerId",
        "headerName": "Id"
      }
    ],
    "id": "LoadBalancerId"
  },
  "tencentcloud.cls": {
    "columns": [
      {
        "type": "string",
        "field": "TopicId",
        "headerName": "Id"
      }
    ],
    "id": "TopicId"
  },
  "tencentcloud.cos": {
    "columns": [
      {
        "type": "string",
        "field": "Name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "Location",
        "headerName": "Location"
      },
      {
        "type": "time",
        "field": "CreationDate",
        "headerName": "Creation Date"
      },
      {
        "type": "string",
        "field": "BucketType",
        "headerName": "Bucket Type"
      }
    ],
    "id": "Name"
  },
  "tencentcloud.cvm": {
    "columns": [
      {
        "type": "string",
        "field": "Placement.Zone",
        "headerName": "Zone"
      },
      {
        "type": "number",
        "field": "Placement.ProjectId",
        "headerName": "Project Id"
      },
      {
        "type": "array",
        "field": "Placement.HostIds",
        "headerName": "Host Ids"
      },
      {
        "type": "string",
        "field": "Placement.HostId",
        "headerName": "Host Id"
      },
      {
        "type": "string",
        "field": "InstanceId",
        "headerName": "Instance Id"
      },
      {
        "type": "string",
        "field": "InstanceType",
        "headerName": "Instance Type"
      },
      {
        "type": "number",
        "field": "CPU",
        "headerName": "CPU"
      },
      {
        "type": "number",
        "field": "Memory",
        "headerName": "Memory"
      },
      {
        "type": "string",
        "field": "RestrictState",
        "headerName": "Restrict State"
      },
      {
        "type": "string",
        "field": "InstanceName",
        "headerName": "Instance Name"
      },
      {
        "type": "string",
        "field": "InstanceChargeType",
        "headerName": "Instance Charge Type"
      },
      {
        "type": "string",
        "field": "SystemDisk.DiskType",
        "headerName": "Disk Type"
      },
      {
        "type": "string",
        "field": "SystemDisk.DiskId",
        "headerName": "Disk Id"
      },
      {
        "type": "number",
        "field": "SystemDisk.DiskSize",
        "headerName": "Disk Size"
      },
      {
        "type": "string",
        "field": "SystemDisk.CdcId",
        "headerName": "Cdc Id"
      },
      {
        "type": "array",
        "field": "PrivateIpAddresses",
        "headerName": "Private Ip Addresses"
      },
      {
        "type": "array",
        "field": "PublicIpAddresses",
        "headerName": "Public Ip Addresses"
      },
      {
        "type": "string",
        "field": "InternetAccessible.InternetChargeType",
        "headerName": "Internet Charge Type"
      },
      {
        "type": "number",
        "field": "InternetAccessible.InternetMaxBandwidthOut",
        "headerName": "Internet Max Bandwidth Out"
      },
      {
        "type": "boolean",
        "field": "InternetAccessible.PublicIpAssigned",
        "headerName": "Public Ip Assigned"
      },
      {
        "type": "string",
        "field": "InternetAccessible.BandwidthPackageId",
        "headerName": "Bandwidth Package Id"
      },
      {
        "type": "string",
        "field": "VirtualPrivateCloud.VpcId",
        "headerName": "Vpc Id"
      },
      {
        "type": "string",
        "field": "VirtualPrivateCloud.SubnetId",
        "headerName": "Subnet Id"
      },
      {
        "type": "boolean",
        "field": "VirtualPrivateCloud.AsVpcGateway",
        "headerName": "As Vpc Gateway"
      },
      {
        "type": "array",
        "field": "VirtualPrivateCloud.PrivateIpAddresses",
        "headerName": "Private Ip Addresses"
      },
      {
        "type": "number",
        "field": "VirtualPrivateCloud.Ipv6AddressCount",
        "headerName": "Ipv6 Address Count"
      },
      {
        "type": "string",
        "field": "ImageId",
        "headerName": "Image Id"
      },
      {
        "type": "string",
        "field": "RenewFlag",
        "headerName": "Renew Flag"
      },
      {
        "type": "time",
        "field": "CreatedTime",
        "headerName": "Created Time"
      },
      {
        "type": "time",
        "field": "ExpiredTime",
        "headerName": "Expired Time"
      },
      {
        "type": "string",
        "field": "OsName",
        "headerName": "Os Name"
      },
      {
        "type": "array",
        "field": "SecurityGroupIds",
        "headerName": "Security Group Ids"
      },
      {
        "type": "string",
        "field": "LoginSettings.Password",
        "headerName": "Password"
      },
      {
        "type": "array",
        "field": "LoginSettings.KeyIds",
        "headerName": "Key Ids"
      },
      {
        "type": "string",
        "field": "LoginSettings.KeepImageLogin",
        "headerName": "Keep Image Login"
      },
      {
        "type": "string",
        "field": "InstanceState",
        "headerName": "Instance State"
      },
      {
        "type": "string",
        "field": "StopChargingMode",
        "headerName": "Stop Charging Mode"
      },
      {
        "type": "string",
        "field": "Uuid",
        "headerName": "Uuid"
      },
      {
        "type": "string",
        "field": "LatestOperation",
        "headerName": "Latest Operation"
      },
      {
        "type": "string",
        "field": "LatestOperationState",
        "headerName": "Latest Operation State"
      },
      {
        "type": "string",
        "field": "LatestOperationRequestId",
        "headerName": "Latest Operation Request Id"
      },
      {
        "type": "string",
        "field": "DisasterRecoverGroupId",
        "headerName": "Disaster Recover Group Id"
      },
      {
        "type": "array",
        "field": "IPv6Addresses",
        "headerName": "I Pv6 Addresses"
      },
      {
        "type": "string",
        "field": "CamRoleName",
        "headerName": "Cam Role Name"
      },
      {
        "type": "string",
        "field": "HpcClusterId",
        "headerName": "Hpc Cluster Id"
      },
      {
        "type": "array",
        "field": "RdmaIpAddresses",
        "headerName": "Rdma Ip Addresses"
      },
      {
        "type": "string",
        "field": "IsolatedSource",
        "headerName": "Isolated Source"
      },
      {
        "type": "number",
        "field": "GPUInfo.GPUCount",
        "headerName": "GPU Count"
      },
      {
        "type": "array",
        "field": "GPUInfo.GPUId",
        "headerName": "GPU Id"
      },
      {
        "type": "string",
        "field": "GPUInfo.GPUType",
        "headerName": "GPU Type"
      },
      {
        "type": "string",
        "field": "LicenseType",
        "headerName": "License Type"
      },
      {
        "type": "boolean",
        "field": "DisableApiTermination",
        "headerName": "Disable Api Termination"
      },
      {
        "type": "string",
        "field": "DefaultLoginUser",
        "headerName": "Default Login User"
      },
      {
        "type": "number",
        "field": "DefaultLoginPort",
        "headerName": "Default Login Port"
      },
      {
        "type": "string",
        "field": "LatestOperationErrorMsg",
        "headerName": "Latest Operation Error Msg"
      }
    ],
    "id": "InstanceId"
  },
  "tencentcloud.dns-record": {
    "columns": [
      {
        "type": "string",
        "field": "DomainId",
        "headerName": "Id"
      }
    ],
    "id": "DomainId"
  },
  "tencentcloud.eip": {
    "columns": [
      {
        "type": "string",
        "field": "AddressId",
        "headerName": "Id"
      }
    ],
    "id": "AddressId"
  },
  "tencentcloud.elasticsearch": {
    "columns": [
      {
        "type": "string",
        "field": "InstanceId",
        "headerName": "Instance Id"
      },
      {
        "type": "string",
        "field": "InstanceName",
        "headerName": "Instance Name"
      },
      {
        "type": "string",
        "field": "Region",
        "headerName": "Region"
      },
      {
        "type": "string",
        "field": "Zone",
        "headerName": "Zone"
      },
      {
        "type": "number",
        "field": "AppId",
        "headerName": "App Id"
      },
      {
        "type": "string",
        "field": "Uin",
        "headerName": "Uin"
      },
      {
        "type": "string",
        "field": "VpcUid",
        "headerName": "Vpc Uid"
      },
      {
        "type": "string",
        "field": "SubnetUid",
        "headerName": "Subnet Uid"
      },
      {
        "type": "number",
        "field": "Status",
        "headerName": "Status"
      },
      {
        "type": "string",
        "field": "RenewFlag",
        "headerName": "Renew Flag"
      },
      {
        "type": "string",
        "field": "ChargeType",
        "headerName": "Charge Type"
      },
      {
        "type": "number",
        "field": "ChargePeriod",
        "headerName": "Charge Period"
      },
      {
        "type": "string",
        "field": "NodeType",
        "headerName": "Node Type"
      },
      {
        "type": "number",
        "field": "NodeNum",
        "headerName": "Node Num"
      },
      {
        "type": "number",
        "field": "CpuNum",
        "headerName": "Cpu Num"
      },
      {
        "type": "number",
        "field": "MemSize",
        "headerName": "Mem Size"
      },
      {
        "type": "string",
        "field": "DiskType",
        "headerName": "Disk Type"
      },
      {
        "type": "number",
        "field": "DiskSize",
        "headerName": "Disk Size"
      },
      {
        "type": "string",
        "field": "EsDomain",
        "headerName": "Es Domain"
      },
      {
        "type": "string",
        "field": "EsVip",
        "headerName": "Es Vip"
      },
      {
        "type": "number",
        "field": "EsPort",
        "headerName": "Es Port"
      },
      {
        "type": "string",
        "field": "KibanaUrl",
        "headerName": "Kibana Url"
      },
      {
        "type": "string",
        "field": "EsVersion",
        "headerName": "Es Version"
      },
      {
        "type": "string",
        "field": "EsConfig",
        "headerName": "Es Config"
      },
      {
        "type": "array",
        "field": "EsAcl.BlackIpList",
        "headerName": "Black Ip List"
      },
      {
        "type": "array",
        "field": "EsAcl.WhiteIpList",
        "headerName": "White Ip List"
      },
      {
        "type": "time",
        "field": "CreateTime",
        "headerName": "Create Time"
      },
      {
        "type": "time",
        "field": "UpdateTime",
        "headerName": "Update Time"
      },
      {
        "type": "string",
        "field": "Deadline",
        "headerName": "Deadline"
      },
      {
        "type": "number",
        "field": "InstanceType",
        "headerName": "Instance Type"
      },
      {
        "type": "string",
        "field": "IkConfig.UpdateType",
        "headerName": "Update Type"
      },
      {
        "type": "boolean",
        "field": "MasterNodeInfo.EnableDedicatedMaster",
        "headerName": "Enable Dedicated Master"
      },
      {
        "type": "string",
        "field": "MasterNodeInfo.MasterNodeType",
        "headerName": "Master Node Type"
      },
      {
        "type": "number",
        "field": "MasterNodeInfo.MasterNodeNum",
        "headerName": "Master Node Num"
      },
      {
        "type": "number",
        "field": "MasterNodeInfo.MasterNodeCpuNum",
        "headerName": "Master Node Cpu Num"
      },
      {
        "type": "number",
        "field": "MasterNodeInfo.MasterNodeMemSize",
        "headerName": "Master Node Mem Size"
      },
      {
        "type": "number",
        "field": "MasterNodeInfo.MasterNodeDiskSize",
        "headerName": "Master Node Disk Size"
      },
      {
        "type": "string",
        "field": "MasterNodeInfo.MasterNodeDiskType",
        "headerName": "Master Node Disk Type"
      },
      {
        "type": "boolean",
        "field": "CosBackup.IsAutoBackup",
        "headerName": "Is Auto Backup"
      },
      {
        "type": "time",
        "field": "CosBackup.BackupTime",
        "headerName": "Backup Time"
      },
      {
        "type": "boolean",
        "field": "AllowCosBackup",
        "headerName": "Allow Cos Backup"
      },
      {
        "type": "string",
        "field": "LicenseType",
        "headerName": "License Type"
      },
      {
        "type": "boolean",
        "field": "EnableHotWarmMode",
        "headerName": "Enable Hot Warm Mode"
      },
      {
        "type": "string",
        "field": "WarmNodeType",
        "headerName": "Warm Node Type"
      },
      {
        "type": "number",
        "field": "WarmNodeNum",
        "headerName": "Warm Node Num"
      },
      {
        "type": "number",
        "field": "WarmCpuNum",
        "headerName": "Warm Cpu Num"
      },
      {
        "type": "number",
        "field": "WarmMemSize",
        "headerName": "Warm Mem Size"
      },
      {
        "type": "string",
        "field": "WarmDiskType",
        "headerName": "Warm Disk Type"
      },
      {
        "type": "number",
        "field": "WarmDiskSize",
        "headerName": "Warm Disk Size"
      },
      {
        "type": "string",
        "field": "EsPublicUrl",
        "headerName": "Es Public Url"
      },
      {
        "type": "number",
        "field": "DeployMode",
        "headerName": "Deploy Mode"
      },
      {
        "type": "string",
        "field": "PublicAccess",
        "headerName": "Public Access"
      },
      {
        "type": "array",
        "field": "EsPublicAcl.BlackIpList",
        "headerName": "Black Ip List"
      },
      {
        "type": "array",
        "field": "EsPublicAcl.WhiteIpList",
        "headerName": "White Ip List"
      },
      {
        "type": "string",
        "field": "KibanaPrivateUrl",
        "headerName": "Kibana Private Url"
      },
      {
        "type": "string",
        "field": "KibanaPublicAccess",
        "headerName": "Kibana Public Access"
      },
      {
        "type": "string",
        "field": "KibanaPrivateAccess",
        "headerName": "Kibana Private Access"
      },
      {
        "type": "number",
        "field": "SecurityType",
        "headerName": "Security Type"
      },
      {
        "type": "number",
        "field": "SceneType",
        "headerName": "Scene Type"
      },
      {
        "type": "string",
        "field": "KibanaConfig",
        "headerName": "Kibana Config"
      },
      {
        "type": "string",
        "field": "KibanaNodeInfo.KibanaNodeType",
        "headerName": "Kibana Node Type"
      },
      {
        "type": "number",
        "field": "KibanaNodeInfo.KibanaNodeNum",
        "headerName": "Kibana Node Num"
      },
      {
        "type": "number",
        "field": "KibanaNodeInfo.KibanaNodeCpuNum",
        "headerName": "Kibana Node Cpu Num"
      },
      {
        "type": "number",
        "field": "KibanaNodeInfo.KibanaNodeMemSize",
        "headerName": "Kibana Node Mem Size"
      },
      {
        "type": "string",
        "field": "KibanaNodeInfo.KibanaNodeDiskType",
        "headerName": "Kibana Node Disk Type"
      },
      {
        "type": "number",
        "field": "KibanaNodeInfo.KibanaNodeDiskSize",
        "headerName": "Kibana Node Disk Size"
      },
      {
        "type": "number",
        "field": "WebNodeTypeInfo.NodeNum",
        "headerName": "Node Num"
      },
      {
        "type": "string",
        "field": "WebNodeTypeInfo.NodeType",
        "headerName": "Node Type"
      },
      {
        "type": "string",
        "field": "Jdk",
        "headerName": "Jdk"
      },
      {
        "type": "string",
        "field": "Protocol",
        "headerName": "Protocol"
      },
      {
        "type": "array",
        "field": "SecurityGroups",
        "headerName": "Security Groups"
      },
      {
        "type": "string",
        "field": "ColdNodeType",
        "headerName": "Cold Node Type"
      },
      {
        "type": "number",
        "field": "ColdNodeNum",
        "headerName": "Cold Node Num"
      },
      {
        "type": "number",
        "field": "ColdCpuNum",
        "headerName": "Cold Cpu Num"
      },
      {
        "type": "number",
        "field": "ColdMemSize",
        "headerName": "Cold Mem Size"
      },
      {
        "type": "string",
        "field": "ColdDiskType",
        "headerName": "Cold Disk Type"
      },
      {
        "type": "number",
        "field": "ColdDiskSize",
        "headerName": "Cold Disk Size"
      },
      {
        "type": "string",
        "field": "FrozenNodeType",
        "headerName": "Frozen Node Type"
      },
      {
        "type": "number",
        "field": "FrozenNodeNum",
        "headerName": "Frozen Node Num"
      },
      {
        "type": "number",
        "field": "FrozenCpuNum",
        "headerName": "Frozen Cpu Num"
      },
      {
        "type": "number",
        "field": "FrozenMemSize",
        "headerName": "Frozen Mem Size"
      },
      {
        "type": "string",
        "field": "FrozenDiskType",
        "headerName": "Frozen Disk Type"
      },
      {
        "type": "number",
        "field": "FrozenDiskSize",
        "headerName": "Frozen Disk Size"
      },
      {
        "type": "number",
        "field": "HealthStatus",
        "headerName": "Health Status"
      },
      {
        "type": "string",
        "field": "EsPrivateUrl",
        "headerName": "Es Private Url"
      },
      {
        "type": "string",
        "field": "EsPrivateDomain",
        "headerName": "Es Private Domain"
      },
      {
        "type": "array",
        "field": "OperationDuration.Periods",
        "headerName": "Periods"
      },
      {
        "type": "time",
        "field": "OperationDuration.TimeStart",
        "headerName": "Time Start"
      },
      {
        "type": "time",
        "field": "OperationDuration.TimeEnd",
        "headerName": "Time End"
      },
      {
        "type": "string",
        "field": "OperationDuration.TimeZone",
        "headerName": "Time Zone"
      },
      {
        "type": "boolean",
        "field": "AutoIndexEnabled",
        "headerName": "Auto Index Enabled"
      },
      {
        "type": "boolean",
        "field": "EnableHybridStorage",
        "headerName": "Enable Hybrid Storage"
      },
      {
        "type": "number",
        "field": "ProcessPercent",
        "headerName": "Process Percent"
      },
      {
        "type": "string",
        "field": "KibanaAlteringPublicAccess",
        "headerName": "Kibana Altering Public Access"
      }
    ],
    "id": "InstanceId"
  },
  "tencentcloud.mysql": {
    "columns": [
      {
        "type": "number",
        "field": "WanStatus",
        "headerName": "Wan Status"
      },
      {
        "type": "string",
        "field": "Zone",
        "headerName": "Zone"
      },
      {
        "type": "number",
        "field": "InitFlag",
        "headerName": "Init Flag"
      },
      {
        "type": "number",
        "field": "RoVipInfo.RoVipStatus",
        "headerName": "Ro Vip Status"
      },
      {
        "type": "number",
        "field": "RoVipInfo.RoSubnetId",
        "headerName": "Ro Subnet Id"
      },
      {
        "type": "number",
        "field": "RoVipInfo.RoVpcId",
        "headerName": "Ro Vpc Id"
      },
      {
        "type": "number",
        "field": "RoVipInfo.RoVport",
        "headerName": "Ro Vport"
      },
      {
        "type": "string",
        "field": "RoVipInfo.RoVip",
        "headerName": "Ro Vip"
      },
      {
        "type": "number",
        "field": "Memory",
        "headerName": "Memory"
      },
      {
        "type": "number",
        "field": "Status",
        "headerName": "Status"
      },
      {
        "type": "number",
        "field": "VpcId",
        "headerName": "Vpc Id"
      },
      {
        "type": "number",
        "field": "SlaveInfo.First.Vport",
        "headerName": "Vport"
      },
      {
        "type": "string",
        "field": "SlaveInfo.First.Region",
        "headerName": "Region"
      },
      {
        "type": "string",
        "field": "SlaveInfo.First.Vip",
        "headerName": "Vip"
      },
      {
        "type": "string",
        "field": "SlaveInfo.First.Zone",
        "headerName": "Zone"
      },
      {
        "type": "number",
        "field": "SlaveInfo.Second.Vport",
        "headerName": "Vport"
      },
      {
        "type": "string",
        "field": "SlaveInfo.Second.Region",
        "headerName": "Region"
      },
      {
        "type": "string",
        "field": "SlaveInfo.Second.Vip",
        "headerName": "Vip"
      },
      {
        "type": "string",
        "field": "SlaveInfo.Second.Zone",
        "headerName": "Zone"
      },
      {
        "type": "string",
        "field": "InstanceId",
        "headerName": "Instance Id"
      },
      {
        "type": "number",
        "field": "Volume",
        "headerName": "Volume"
      },
      {
        "type": "number",
        "field": "AutoRenew",
        "headerName": "Auto Renew"
      },
      {
        "type": "number",
        "field": "ProtectMode",
        "headerName": "Protect Mode"
      },
      {
        "type": "number",
        "field": "SubnetId",
        "headerName": "Subnet Id"
      },
      {
        "type": "number",
        "field": "InstanceType",
        "headerName": "Instance Type"
      },
      {
        "type": "number",
        "field": "ProjectId",
        "headerName": "Project Id"
      },
      {
        "type": "string",
        "field": "Region",
        "headerName": "Region"
      },
      {
        "type": "time",
        "field": "DeadlineTime",
        "headerName": "Deadline Time"
      },
      {
        "type": "number",
        "field": "DeployMode",
        "headerName": "Deploy Mode"
      },
      {
        "type": "number",
        "field": "TaskStatus",
        "headerName": "Task Status"
      },
      {
        "type": "string",
        "field": "MasterInfo.Region",
        "headerName": "Region"
      },
      {
        "type": "number",
        "field": "MasterInfo.RegionId",
        "headerName": "Region Id"
      },
      {
        "type": "number",
        "field": "MasterInfo.ZoneId",
        "headerName": "Zone Id"
      },
      {
        "type": "string",
        "field": "MasterInfo.Zone",
        "headerName": "Zone"
      },
      {
        "type": "string",
        "field": "MasterInfo.InstanceId",
        "headerName": "Instance Id"
      },
      {
        "type": "string",
        "field": "MasterInfo.ResourceId",
        "headerName": "Resource Id"
      },
      {
        "type": "number",
        "field": "MasterInfo.Status",
        "headerName": "Status"
      },
      {
        "type": "string",
        "field": "MasterInfo.InstanceName",
        "headerName": "Instance Name"
      },
      {
        "type": "number",
        "field": "MasterInfo.InstanceType",
        "headerName": "Instance Type"
      },
      {
        "type": "number",
        "field": "MasterInfo.TaskStatus",
        "headerName": "Task Status"
      },
      {
        "type": "number",
        "field": "MasterInfo.Memory",
        "headerName": "Memory"
      },
      {
        "type": "number",
        "field": "MasterInfo.Volume",
        "headerName": "Volume"
      },
      {
        "type": "string",
        "field": "MasterInfo.DeviceType",
        "headerName": "Device Type"
      },
      {
        "type": "number",
        "field": "MasterInfo.Qps",
        "headerName": "Qps"
      },
      {
        "type": "number",
        "field": "MasterInfo.VpcId",
        "headerName": "Vpc Id"
      },
      {
        "type": "number",
        "field": "MasterInfo.SubnetId",
        "headerName": "Subnet Id"
      },
      {
        "type": "string",
        "field": "MasterInfo.ExClusterId",
        "headerName": "Ex Cluster Id"
      },
      {
        "type": "string",
        "field": "MasterInfo.ExClusterName",
        "headerName": "Ex Cluster Name"
      },
      {
        "type": "string",
        "field": "DeviceType",
        "headerName": "Device Type"
      },
      {
        "type": "string",
        "field": "EngineVersion",
        "headerName": "Engine Version"
      },
      {
        "type": "string",
        "field": "InstanceName",
        "headerName": "Instance Name"
      },
      {
        "type": "string",
        "field": "WanDomain",
        "headerName": "Wan Domain"
      },
      {
        "type": "number",
        "field": "WanPort",
        "headerName": "Wan Port"
      },
      {
        "type": "number",
        "field": "PayType",
        "headerName": "Pay Type"
      },
      {
        "type": "time",
        "field": "CreateTime",
        "headerName": "Create Time"
      },
      {
        "type": "string",
        "field": "Vip",
        "headerName": "Vip"
      },
      {
        "type": "number",
        "field": "Vport",
        "headerName": "Vport"
      },
      {
        "type": "number",
        "field": "CdbError",
        "headerName": "Cdb Error"
      },
      {
        "type": "string",
        "field": "UniqVpcId",
        "headerName": "Uniq Vpc Id"
      },
      {
        "type": "string",
        "field": "UniqSubnetId",
        "headerName": "Uniq Subnet Id"
      },
      {
        "type": "string",
        "field": "PhysicalId",
        "headerName": "Physical Id"
      },
      {
        "type": "number",
        "field": "Cpu",
        "headerName": "Cpu"
      },
      {
        "type": "number",
        "field": "Qps",
        "headerName": "Qps"
      },
      {
        "type": "string",
        "field": "ZoneName",
        "headerName": "Zone Name"
      },
      {
        "type": "string",
        "field": "DeviceClass",
        "headerName": "Device Class"
      },
      {
        "type": "string",
        "field": "DeployGroupId",
        "headerName": "Deploy Group Id"
      },
      {
        "type": "number",
        "field": "ZoneId",
        "headerName": "Zone Id"
      },
      {
        "type": "number",
        "field": "InstanceNodes",
        "headerName": "Instance Nodes"
      },
      {
        "type": "string",
        "field": "EngineType",
        "headerName": "Engine Type"
      },
      {
        "type": "number",
        "field": "MaxDelayTime",
        "headerName": "Max Delay Time"
      }
    ],
    "id": "InstanceId"
  },
  "tencentcloud.mysql-backup": {
    "columns": [
      {
        "type": "string",
        "field": "Name",
        "headerName": "Name"
      },
      {
        "type": "number",
        "field": "Size",
        "headerName": "Size"
      },
      {
        "type": "time",
        "field": "Date",
        "headerName": "Date"
      },
      {
        "type": "string",
        "field": "IntranetUrl",
        "headerName": "Intranet Url"
      },
      {
        "type": "string",
        "field": "InternetUrl",
        "headerName": "Internet Url"
      },
      {
        "type": "string",
        "field": "Type",
        "headerName": "Type"
      },
      {
        "type": "number",
        "field": "BackupId",
        "headerName": "Backup Id"
      },
      {
        "type": "string",
        "field": "Status",
        "headerName": "Status"
      },
      {
        "type": "time",
        "field": "FinishTime",
        "headerName": "Finish Time"
      },
      {
        "type": "string",
        "field": "Creator",
        "headerName": "Creator"
      },
      {
        "type": "time",
        "field": "StartTime",
        "headerName": "Start Time"
      },
      {
        "type": "string",
        "field": "Method",
        "headerName": "Method"
      },
      {
        "type": "string",
        "field": "Way",
        "headerName": "Way"
      },
      {
        "type": "string",
        "field": "ManualBackupName",
        "headerName": "Manual Backup Name"
      },
      {
        "type": "string",
        "field": "SaveMode",
        "headerName": "Save Mode"
      },
      {
        "type": "string",
        "field": "Region",
        "headerName": "Region"
      },
      {
        "type": "number",
        "field": "CosStorageType",
        "headerName": "Cos Storage Type"
      },
      {
        "type": "string",
        "field": "InstanceId",
        "headerName": "Instance Id"
      },
      {
        "type": "string",
        "field": "EncryptionFlag",
        "headerName": "Encryption Flag"
      }
    ],
    "id": "InstanceId"
  },
  "tencentcloud.nat-gateway": {
    "columns": [
      {
        "type": "string",
        "field": "NatGatewayId",
        "headerName": "Nat Gateway Id"
      },
      {
        "type": "string",
        "field": "NatGatewayName",
        "headerName": "Nat Gateway Name"
      },
      {
        "type": "time",
        "field": "CreatedTime",
        "headerName": "Created Time"
      },
      {
        "type": "string",
        "field": "State",
        "headerName": "State"
      },
      {
        "type": "number",
        "field": "InternetMaxBandwidthOut",
        "headerName": "Internet Max Bandwidth Out"
      },
      {
        "type": "number",
        "field": "MaxConcurrentConnection",
        "headerName": "Max Concurrent Connection"
      },
      {
        "type": "string",
        "field": "NetworkState",
        "headerName": "Network State"
      },
      {
        "type": "string",
        "field": "VpcId",
        "headerName": "Vpc Id"
      },
      {
        "type": "string",
        "field": "Zone",
        "headerName": "Zone"
      },
      {
        "type": "array",
        "field": "DirectConnectGatewayIds",
        "headerName": "Direct Connect Gateway Ids"
      },
      {
        "type": "string",
        "field": "SubnetId",
        "headerName": "Subnet Id"
      },
      {
        "type": "array",
        "field": "SecurityGroupSet",
        "headerName": "Security Group Set"
      },
      {
        "type": "boolean",
        "field": "IsExclusive",
        "headerName": "Is Exclusive"
      },
      {
        "type": "number",
        "field": "ExclusiveGatewayBandwidth",
        "headerName": "Exclusive Gateway Bandwidth"
      },
      {
        "type": "string",
        "field": "RestrictState",
        "headerName": "Restrict State"
      }
    ],
    "id": "NatGatewayId"
  },
  "tencentcloud.security-group": {
    "columns": [
      {
        "type": "string",
        "field": "SecurityGroupId",
        "headerName": "Security Group Id"
      },
      {
        "type": "string",
        "field": "SecurityGroupName",
        "headerName": "Security Group Name"
      },
      {
        "type": "string",
        "field": "SecurityGroupDesc",
        "headerName": "Security Group Desc"
      },
      {
        "type": "string",
        "field": "ProjectId",
        "headerName": "Project Id"
      },
      {
        "type": "boolean",
        "field": "IsDefault",
        "headerName": "Is Default"
      },
      {
        "type": "time",
        "field": "CreatedTime",
        "headerName": "Created Time"
      },
      {
        "type": "time",
        "field": "UpdateTime",
        "headerName": "Update Time"
      }
    ],
    "id": "SecurityGroupId"
  },
  "tencentcloud.subnet": {
    "columns": [
      {
        "type": "string",
        "field": "SubnetId",
        "headerName": "Id"
      }
    ],
    "id": "SubnetId"
  },
  "tencentcloud.tcr": {
    "columns": [
      {
        "type": "string",
        "field": "RegistryId",
        "headerName": "Registry Id"
      },
      {
        "type": "string",
        "field": "RegistryName",
        "headerName": "Registry Name"
      },
      {
        "type": "string",
        "field": "RegistryType",
        "headerName": "Registry Type"
      },
      {
        "type": "string",
        "field": "Status",
        "headerName": "Status"
      },
      {
        "type": "string",
        "field": "PublicDomain",
        "headerName": "Public Domain"
      },
      {
        "type": "string",
        "field": "CreatedAt",
        "headerName": "Created At"
      },
      {
        "type": "string",
        "field": "RegionName",
        "headerName": "Region Name"
      },
      {
        "type": "number",
        "field": "RegionId",
        "headerName": "Region Id"
      },
      {
        "type": "boolean",
        "field": "EnableAnonymous",
        "headerName": "Enable Anonymous"
      },
      {
        "type": "number",
        "field": "TokenValidTime",
        "headerName": "Token Valid Time"
      },
      {
        "type": "string",
        "field": "InternalEndpoint",
        "headerName": "Internal Endpoint"
      },
      {
        "type": "string",
        "field": "TagSpecification.ResourceType",
        "headerName": "Resource Type"
      },
      {
        "type": "string",
        "field": "ExpiredAt",
        "headerName": "Expired At"
      },
      {
        "type": "number",
        "field": "PayMod",
        "headerName": "Pay Mod"
      },
      {
        "type": "number",
        "field": "RenewFlag",
        "headerName": "Renew Flag"
      }
    ],
    "id": "RegistryId"
  },
  "tencentcloud.vpc": {
    "columns": [
      {
        "type": "string",
        "field": "VpcName",
        "headerName": "Vpc Name"
      },
      {
        "type": "string",
        "field": "VpcId",
        "headerName": "Vpc Id"
      },
      {
        "type": "string",
        "field": "CidrBlock",
        "headerName": "Cidr Block"
      },
      {
        "type": "boolean",
        "field": "IsDefault",
        "headerName": "Is Default"
      },
      {
        "type": "boolean",
        "field": "EnableMulticast",
        "headerName": "Enable Multicast"
      },
      {
        "type": "time",
        "field": "CreatedTime",
        "headerName": "Created Time"
      },
      {
        "type": "array",
        "field": "DnsServerSet",
        "headerName": "Dns Server Set"
      },
      {
        "type": "string",
        "field": "DomainName",
        "headerName": "Domain Name"
      },
      {
        "type": "string",
        "field": "DhcpOptionsId",
        "headerName": "Dhcp Options Id"
      },
      {
        "type": "boolean",
        "field": "EnableDhcp",
        "headerName": "Enable Dhcp"
      },
      {
        "type": "string",
        "field": "Ipv6CidrBlock",
        "headerName": "Ipv6 Cidr Block"
      }
    ],
    "id": "VpcId"
  }
}
